module.exports = __webpack_public_path__ + "static/media/trust_made_in_germany.78f46343.svg";